import { axios } from '../../services/axios';

export default async function getSRTRegionsForCompany(companyID) {
    const result = await axios.get(
        `/Services/SRT/Company/${companyID}/Regions/Available`,
    );
    return result;
}
